import { baseUrl } from "./baseUrl";
import { fetchJSON } from "./fetchJSON";

export type CodeSociete = {
  id: number;
  type: string;
  code: string;
  nom: string;
  actif?: boolean;
  label: string | undefined;
};

export function getCodesSocietesActives() {
  const url = new URL("/backend/v1/codes-societes", baseUrl);
  url.searchParams.append("all", "false");
  return fetchJSON<CodeSociete[]>(url);
}

export function getAllCodesSocietes() {
  const url = new URL("/backend/v1/codes-societes", baseUrl);
  url.searchParams.append("all", "true");
  return fetchJSON<CodeSociete[]>(url);
}
